import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { Router, NavigationEnd } from '@angular/router';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { Component, Input, OnInit, ViewEncapsulation, AfterViewInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ShareDataService } from 'projects/shared/src/app/shared/share-data.service';
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { LoginService } from 'projects/services/src/app/API/login/login.service';
import { StorageService } from 'projects/services/src/app/storage.service';
declare var swal: any;
declare var mLayout: any;
@Component({
	selector: 'app-header-nav',
	templateUrl: './header-nav.component.html',
	styleUrls: ['./header-nav.component.css'],
	encapsulation: ViewEncapsulation.None,
})
export class HeaderNavComponent implements OnInit, AfterViewInit, OnDestroy {
	userInfo: { userName: string, email: string, contactDetails: { email: string }, trainingCentreName: string, role: string }
		= { userName: '', email: '', contactDetails: { email: '' }, trainingCentreName: '', role: '' };
	userData: any = {};
	@Input() navElements: any[] = [];
	@Input() userSetting: any;
	@Output() stage = new EventEmitter<any>();
	dashboardValue: string = "";
	constructor(
		private router: Router,
		private loginService: LoginService,
		private storageService: StorageService,
		private currentUserService: CurrentUserService,
		private shareDataService: ShareDataService,
		private fileService: FileService
	) { }
	ngOnInit() {
		this.userData = this.shareDataService.getSharedData();
		this.navElements = this.navElements.filter(elem => !elem.notShow)
		this.currentUserService.getCurrentUser()
			.subscribe(loggedInUserInfo => {
				if (loggedInUserInfo) {
					this.userInfo = loggedInUserInfo;
					if (!(this.userInfo && this.userInfo.email) && (this.userInfo && this.userInfo.contactDetails && this.userInfo.contactDetails.email && Helpers.getValueFromObject(this, 'userInfo.contactDetails.email'))) {
						this.userInfo.email = this.userInfo.contactDetails.email;
					}
					if (loggedInUserInfo.personalDetails && loggedInUserInfo.personalDetails.profilePicture) {
						// console.log(this.getProfile(loggedInUserInfo.personalDetails.profilePicture), 'candidate profile');
					}
				} else {
					this.currentUserService.getAdditionalInfomartion().subscribe(res => {
						this.userInfo = res;
					})
				}

			});
		this.clear();
	}

	ngAfterViewInit() {
		mLayout.initHeader();
	}
	navigateTo(route , query?) {
		if(query !== undefined){
			this.router.navigate([`/${route}`], {queryParams: {[query.key ]: [query.value]}});
		} else if (route) {
			this.router.navigate([`/${route}`]);
		}
	}

	navigateToRouteWithQuery(value){
		this.stage.emit(value);
		// if(element.query !== undefined){
		// 	this.router.navigate([`/${element.route}`], {queryParams: element.query});
		// } else if (element.route) {
		// 	this.router.navigate([`/${element.route}`]);
		// }
	}

	navigateToTrainingPartner(value){
		this.stage.emit(value);
	}

	logout() {
		const cred = {
			userName: this.userInfo.userName
		};
		this.loginService.logout(cred).subscribe(res => {
			this.router.navigate(['/']);
			this.storageService.removeAll();
			this.currentUserService.SetCurrentUserOnLogout();
		}, err => {
			this.router.navigate(['/']);
			this.storageService.removeAll();
			this.currentUserService.SetCurrentUserOnLogout();
		}
		);
	}

	helpUser() {
		let requiredURL
		this.fileService.getImageURL(requiredURL).subscribe((signedURL: string) => {
			window.open(signedURL, "_blank")
		})
	}

	// getProfile(imageUrl) {
	// 	return this.shareDataService.getImage(imageUrl);
	// }
	ngOnDestroy() {
		this.shareDataService.setImage(undefined);
	}

	clear() {
		this.router.events.subscribe((route: any) => {
			if (route instanceof NavigationEnd) {
				if (route.url === '/ssc/etacp-dashboard' || route.url === '/ssc/kpi-dashboard' || route.url === '/ssc/batch-tracking-dashboard' || route.url === '/ssc/certificate-marksheet' || route.url === '/ssc/assessment-fees') {
					console.log("dashboard value123455555 ", this.dashboardValue)
				} else {
					this.dashboardValue = "";
				}
			}

		});
	}
	// sscab() {
	// 	console.log("@@@@@!!!!!!!!!userrrrr", this.userInfo)
	// 	console.log("###########", this.dashboardValue)
	// 	if (this.dashboardValue === "etacp") {
	// 		this.router.navigate(['/ssc/etacp-dashboard']);
	// 	} else if (this.dashboardValue === "kpi") {
	// 		this.router.navigate(['/ssc/kpi-dashboard']);
	// 	} else if (this.dashboardValue === "batchTracking") {
	// 		this.router.navigate(['/ssc/batch-tracking-dashboard']);
	// 	} else if (this.dashboardValue === "certifAndMark") {
	// 		this.router.navigate(['/ssc/certificate-marksheet']);
	// 	} else if (this.dashboardValue === "asseFee") {
	// 		this.router.navigate(['/ssc/assessment-fees']);
	// 	}

	// }

}
